import axios from 'axios'
import _ from 'lodash'
import store from '../store/store'
export default () => {
  
  const apiDomain = _.get(store.state, 'apiDomain', 'https://api.gofundraise.com') 
  const region = _.get(store.state, 'region', 'au')

  return {
    /*
     * Get beneficiaries from API using custom query params
     */
    async searchWithParams(params) {
      if (params) {
        params.region = region
      }
      
      return await axios.get(apiDomain + '/v1/beneficiaries/search', { params: params })
    },

    /*
    * Get beneficiaries from API for a specific event
    */
    async searchByEvent(eventCampaignId) {
      return await this.searchWithParams({
        eventcampaignid: eventCampaignId
      })
    },

    /*
    * Get beneficiary details for event
    */
    async getBeneficiaryDetailsForEvent(beneficiaryId, eventCampaignId) {
      return await this.searchWithParams({
        eventcampaignid: eventCampaignId,
        beneficiaryid: beneficiaryId
      })
    },

    /*
    * Get beneficiary details by Id
    */
    async getBeneficiaryById(beneficiaryId) {
      return await this.searchWithParams({
        beneficiaryid: beneficiaryId
      })
    },
  }
}
